import { keepTrackApi } from '@app/keepTrackApi';
import { MenuMode } from '@app/engine/core/interfaces';
import { EventBus } from '@app/engine/events/event-bus';
import { EventBusEvent } from '@app/engine/events/event-bus-events';
import dayNightPng from '@public/img/icons/day-night.png';
import { KeepTrackPlugin } from '../../engine/plugins/base-plugin';
import { SoundNames } from '../sounds/sounds';
export class NightToggle extends KeepTrackPlugin {
    id = 'NightToggle';
    dependencies_ = [];
    bottomIconImg = dayNightPng;
    menuMode = [MenuMode.ADVANCED, MenuMode.ALL];
    addJs() {
        super.addJs();
        EventBus.getInstance().on(EventBusEvent.KeyDown, (key, _code, isRepeat) => {
            if (key === 'N' && !isRepeat) {
                this.toggleNightMode();
            }
        });
    }
    bottomIconCallback = () => {
        this.toggleNightMode();
    };
    toggleNightMode() {
        if (this.isMenuButtonActive) {
            this.on();
        }
        else {
            this.off();
        }
    }
    on() {
        keepTrackApi.getSoundManager()?.play(SoundNames.TOGGLE_ON);
        settingsManager.isDrawNightAsDay = true;
        this.setBottomIconToSelected();
    }
    off() {
        keepTrackApi.getSoundManager()?.play(SoundNames.TOGGLE_OFF);
        settingsManager.isDrawNightAsDay = false;
        this.setBottomIconToUnselected();
    }
}
